import React from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, UploadOutlined } from '@ant-design/icons';

import { Card, Row, Col, Upload, Button, Progress, notification, Typography } from 'antd';
import { FormikButton } from '../../Components/Formik';

import AdvShipExcel01Actions from '../../Stores/AdvShipExcel01/Actions';

const { Text } = Typography;

class AdvShipExcel01Form extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      uploadFile: []
    };

    this.useOnUpload = this.useOnUpload.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {
    const { uploadIsLoading, showBatchJobStatus } = this.props;

    if (uploadIsLoading) {
      setTimeout(() => {
        showBatchJobStatus();
      }, 10000);
    }
  }

  componentWillUnmount() {}

  useOnUpload(values, formikBag) {
    const { uploadExcel } = this.props;
    const { uploadFile } = this.state;

    if (uploadFile.length > 0) {
      uploadExcel(formikBag, uploadFile[0]);
    }
  }

  render() {
    const { intl, uploadIsLoading, batchJobStatus } = this.props;
    const { uploadFile } = this.state;

    return (
      <Card>
        <Formik enableReinitialize onSubmit={this.useOnUpload}>
          {({
            // values,
            // handleChange,
            // errors,
            // setFieldTouched,
            dirty,
            // touched,
            isSubmitting,
            // isValid,
            handleSubmit,
            handleReset
          }) => (
            <Form>
              <Row type="flex" justify="start" gutter={[0, 8]}>
                <Col span={3}>
                  <Text>{intl.formatMessage({ id: 'file' })}</Text>
                </Col>
                <Col span={1}>
                  <Text>:</Text>
                </Col>
                <Col span={12}>
                  <Upload
                    disabled={uploadIsLoading}
                    onRemove={() => {
                      this.setState({
                        uploadFile: []
                      });
                    }}
                    beforeUpload={file => {
                      const validFileName1 = 'GOOD RECEIVED NOTE';
                      if (file && file.name.toUpperCase().includes(validFileName1)) {
                        this.setState({
                          uploadFile: [file]
                        });
                      } else {
                        notification.error({
                          message: `${intl.formatMessage({
                            id: 'invalid_file_name_must_contain'
                          })} ${validFileName1}`,
                          duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
                        });
                      }

                      return false;
                    }}
                    fileList={uploadFile}
                  >
                    <Button type="primary" loading={uploadIsLoading}>
                      {intl.formatMessage({ id: 'browse' })}
                    </Button>
                  </Upload>
                </Col>
              </Row>

              <Row type="flex" justify="start" gutter={[0, 16]}>
                <Col span={6}>
                  <Button
                    type="primary"
                    disabled={!dirty}
                    loading={isSubmitting}
                    onClick={handleReset}
                    icon={<UndoOutlined />}
                  >
                    {intl.formatMessage({ id: 'reset' })}
                  </Button>
                  <Field
                    type="primary"
                    name="upload_action"
                    value="update"
                    component={FormikButton}
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    label={intl.formatMessage({
                      id: 'upload'
                    })}
                    icon={<UploadOutlined />}
                    disabled={uploadFile.length === 0}
                  />
                </Col>
              </Row>
              <Row type="flex" justify="center" gutter={[0, 8]}>
                <Col span={24}>
                  <Progress percent={parseInt(batchJobStatus.status_number, 10)} />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card>
    );
  }
}

AdvShipExcel01Form.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  batchJobStatus: PropTypes.shape({
    status_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  uploadIsLoading: PropTypes.bool,

  showBatchJobStatus: PropTypes.func,
  uploadExcel: PropTypes.func
};

AdvShipExcel01Form.defaultProps = {
  intl: {},

  batchJobStatus: {
    status_number: '0'
  },
  uploadIsLoading: false,

  showBatchJobStatus() {},
  uploadExcel() {}
};

const mapStateToProps = state => ({
  batchJobStatus: state.advShipExcel01.batchJobStatus,
  uploadIsLoading: state.advShipExcel01.uploadIsLoading
});

const mapDispatchToProps = dispatch => ({
  showBatchJobStatus: () => dispatch(AdvShipExcel01Actions.advShipExcel01ShowBatchJobStatus()),
  uploadExcel: (formikBag, file) =>
    dispatch(AdvShipExcel01Actions.advShipExcel01UploadExcel(formikBag, file))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AdvShipExcel01Form));
